import { render, staticRenderFns } from "./MlFooter.vue?vue&type=template&id=6afd9c2c&"
import script from "./MlFooter.vue?vue&type=script&lang=js&"
export * from "./MlFooter.vue?vue&type=script&lang=js&"
import style0 from "./MlFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports